import React, { useEffect, useState } from "react";
import LoadingScreen from "../components/loadinganimation";
import axios from "axios";

function UserPlans() {
  const [plans, setPlans] = useState([]);
  const [fadeInButton, setFadeInButton] = useState(false); // State to control button fade in
  const [fadeInItems, setFadeInItems] = useState(false); // State to control items fade in
  const [fadeInHeader, setFadeInHeader] = useState(false); // State to control header fade in
  const [fadeInLogout, setFadeInLogout] = useState(false); // State to control logout fade in
  const [name, setName] = useState("ERROR");

  const addNew = () => {
    window.location.href = process.env.REACT_APP_App_Url + "create/plan/user";
  };

  const handleDelete = (id) => {
    axios
    .post(process.env.REACT_APP_Apiurl + "deleteplan", {Id: id})
    .then((res) => {
        axios.get(process.env.REACT_APP_Apiurl + "overview").then((res) => {
            setPlans(res.data.plans);
          });
    })
    .catch((error) => console.log(error));
  };

  const handleClick = (code) => {
    window.location.href = process.env.REACT_APP_App_Url + "planner/" + code;
  };

  const handleLogout = () => {
    localStorage.setItem("token", "");
    axios
      .get(process.env.REACT_APP_Apiurl + "logout")
      .then((res) => {
        window.location.href = process.env.REACT_APP_App_Url;
      })
      .catch((error) => console.log(error));
  };

  axios.defaults.withCredentials = true;

  useEffect(() => {
    // Simulating data fetch from backend
    axios.get(process.env.REACT_APP_Apiurl + "overview").then((res) => {
      console.log(res)
        if(!res.data.Authorized){
            window.location.href = process.env.REACT_APP_App_Url;
        }
      setPlans(res.data.plans);
      setName(res.data.name[0].First_Name);

      // Sequential fade-in effect
      setTimeout(() => {
        setFadeInHeader(true);
      }, 200); // Delay for header

      setTimeout(() => {
        setFadeInButton(true);
      }, 300); // Delay for button

      setTimeout(() => {
        setFadeInItems(true);
      }, 400); // Delay for items

      setTimeout(() => {
        setFadeInLogout(true);
      }, 800); // Delay for logout
    });
  }, []); // Empty dependency array ensures effect runs only once

  return (
    <div
      className={`flex-col flex items-center justify-center h-screen bg-[#121212] text-white `}
    >
      <h1
        className={`font-bold text-3xl mb-5 ${
          fadeInHeader
            ? "opacity-100 transition-opacity duration-1000 ease-in-out"
            : "opacity-0"
        }`}
      >
        Hi {name}! You have {plans === null ? 0:plans.length} saved course plans :)
      </h1>

      <a
        onClick={addNew}
        className={`rounded-md px-3.5 py-2 m-1 mb-5 overflow-hidden relative group cursor-pointer border-2 font-medium border-[#FFD700] text-[#FFD700] text-white transition-opacity ${
          fadeInButton
            ? "opacity-100 transition-opacity duration-1000 ease-in-out"
            : "opacity-0"
        }`}
      >
        <span className="absolute w-64 h-0 transition-all duration-300 origin-center rotate-45 -translate-x-20 bg-[#FFD700] top-1/2 group-hover:h-64 group-hover:-translate-y-32 ease"></span>
        <span className="relative text-[#FFD700] transition duration-300 group-hover:text-white ease">
          Create New
        </span>
      </a>

      {plans.map((item, i) => (
        <div className={` mb-10 flex items-center ${
            fadeInItems
              ? "animate-fade-in transition-opacity duration-1000 ease-in-out"
              : "opacity-0"
          }`} style={{ transitionDelay: `${200 + i * 100}ms` }}>
          <button
            onClick={() => handleClick(item.Id)}
            key={i}
            className={`flex bg-[#C3DEFE33] min-w-[50vw] rounded-lg text-gray-300 p-6 hover:bg-[#c3defe4f] `}
            style={{ transitionDelay: `${200 + i * 100}ms` }}
          >
            <div className="grow text-left">
              <p className="font-bold text-xl">{item.name}</p>
            </div>
            <div className="grow text-right">
              <p>Created on {item.Created_On}</p>
            </div>
          </button>

          <button onClick = {() => handleDelete(item.Id)}className="bg-red-500 hover:text-red-700  rounded-lg ml-2 p-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      ))}

      <p
        className={`text-[#FFD700] hover:text-[#ffd900d3] hover:cursor-pointer ${
          fadeInLogout
            ? "opacity-100 transition-opacity duration-1000 ease-in-out"
            : "opacity-0"
        }`}
        onClick={handleLogout}
      >
        Log out
      </p>
    </div>
  );
}

export default UserPlans;
